module.exports = __webpack_public_path__ + "img/icb-del-novice-m@2x.b185d157.png";